import { Component, Input, OnChanges, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-timeline',
    styleUrls: ['timeline.component.css'],
    templateUrl: 'timeline.component.html',
})
export class TimelineComponent implements OnInit, OnDestroy, OnChanges {
    // Inputs
    @Input() backColor: string;
    @Input() color: string;
    @Input() currentStep: number;
    @Input() steps: TimelineStepInfo[];

    // Class
    BarPercent: number;
    ticks: number[];

    constructor() {}

    ngOnDestroy() {}

    ngOnInit() {}

    ngOnChanges() {
        const self = this;

        if (!self.steps || !self.steps.length) {
            return;
        }

        const numticks = self.steps.length;
        const tickPercent = 100.0 / numticks;

        const tempticks = [];
        for (let i = 1; i <= numticks; ++i) {
            tempticks.push(tickPercent * i);
        }

        self.ticks = tempticks;
        self.BarPercent = self.ticks[self.currentStep];
    }
}

// #region Custom Classes

// #region Timeline Step Info Class

export class TimelineStepInfo {
    Description: string;
    NextStep?: string;
    Tooltip?: string;
    Warning?: string;
}

// #endregion

// #endregion



// WEBPACK FOOTER //
// ./src/app/ui/timeline/timeline.component.ts